// extracted by mini-css-extract-plugin
export default {"pageBody":"index_pageBody_X4u-J","content_list":"index_content_list_Ixofq","chip_item":"index_chip_item_enl8i"};